export default function KpiTile({ label, value, sub, variant = "default", testid }) {
  const cls = variant === "money" ? "kpi-tile money" : variant === "accent" ? "kpi-tile accent" : "kpi-tile";
  const valueCls = variant === "money" ? "text-evergreen" : "text-navy";
  return (
    <div className={cls} data-testid={testid}>
      <div className="text-xs uppercase tracking-[0.2em] text-midnight opacity-70">{label}</div>
      <div className={`mt-2 text-2xl md:text-3xl font-bold ${valueCls}`}>{value}</div>
      {sub && <div className="mt-1 text-xs text-midnight opacity-60">{sub}</div>}
    </div>
  );
}
